<template>
  <article class="snapsheet-page" :class="{ 'create-mode': isCreateMode }">
    <!-- Mini Dealer Header -->
    <article v-if="isCreateMode" class="mini-dealer-header">
      <div class="rep-info">
        <p class="rep-name">
          {{ (projectRep && projectRep.name) || "Rep Name" }}
        </p>
        <div class="rep-phone">
          <img
            class="d-img"
            src="@/assets/icons/ui/call-outline.png"
            alt="phone icon"
          />
          <p class="rep-phone-text">
            {{ repPhone || "+1-123-456-7890" }}
          </p>
        </div>
        <div class="rep-email">
          <img
            class="d-img"
            src="@/assets/icons/ui/mail-outline.png"
            alt="email icon"
          />
          <p class="rep-email-text">
            {{ (projectRep && projectRep.email) || "yourRep@reps.com" }}
          </p>
        </div>
      </div>
      <img class="dealer-logo d-img" :src="dealer.logo" alt="dealer logo" />
    </article>
    <Product
      v-for="(product, index) in page.products"
      :key="index + '-item-' + pageId"
      :withDescription="true"
      :originalProduct="product"
      :isPlaceholderPage="isPlaceholderPage"
      :isUniqueProductInPage="isUniqueProductInPage"
      :pageType="'snapsheet'"
      :readOnly="readOnly"
      :withImage="true"
      @openSearchModal="emitOpenSearchModal"
      @openPreviewNewLockerProducts="emitOpenPreviewNewLockerProducts"
    />

    <div v-if="isPlaceholderPage" class="placeholder-text">
      Create a custom team catalog for any sport and activity. Features
      <strong>your branding</strong> , personalized for
      <strong>your customer's team colors</strong>
    </div>

    <p v-if="!isPlaceholderPage" class="footer-explainer">
      TEAM EQUIPMENT, UNIFORMS, AND APPAREL FOR MIDDLE AND HIGH SCHOOLS,
      COLLEGES, RECREATION DEPARTMENTS, TRAVEL TEAMS, AND RETAIL
    </p>

    <!-- <p class="page-footer">{{ pageId }}</p> -->
  </article>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Product from "@/components/Projects/Product/Product.vue";

import CONSTANTS from "@/constants";
export default {
  name: "SnapsheetPage",
  components: { Product },

  props: {
    pageId: {
      type: Number,
    },
    page: {
      type: Object,
    },
    readOnly: {
      type: Boolean,
    },
  },

  data() {
    return {
      tempTitle: "",
      screenWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapState("snapsheet", [
      "products",
      "pages",
      "projectTitle",
      "editTitleActive",
    ]),
    ...mapState("auth", ["dealerMode"]),
    ...mapState(["dealer"]),
    ...mapState("project", ["loading"]),
    ...mapGetters("project", ["projectTitle", "projectRep", "isCreateMode"]),

    isMobile() {
      return this.screenWidth <= 1024;
    },

    editTitleEnabled() {
      if (this.isMobile) return true;
      return !!(this.pageId % 2);
    },

    isPlaceholderPage() {
      return (
        this.pageId === 1 &&
        this.page.products.filter((pr) => pr.id)?.length === 1 &&
        this.products[0]?.alias ===
          CONSTANTS.SNAPSHEET_PLACEHOLDER_PRODUCT_ALIAS &&
        this.isCreateMode
      );
    },

    isUniqueProductInPage() {
      return this.page.products.filter((pr) => pr.id).length === 1;
    },

    repPhone() {
      const phone = this.projectRep?.phone;
      if (!phone) return null;
      return phone?.includes("-")
        ? phone
        : `(${phone.substring(0, 3)}) ${phone.substring(
            3,
            6
          )}-${phone.substring(6)}`;
    },
  },

  methods: {
    ...mapActions("snapsheet", [
      "toggleEditTitleActive",
      "updateSnapsheetTitle",
    ]),
    saveEditTitle() {
      this.updateSnapsheetTitle({ title: this.tempTitle });
      this.toggleEditTitleActive();
    },
    toggleEditTitle() {
      this.tempTitle = this.projectTitle;
      this.toggleEditTitleActive();
    },

    onResize() {
      this.screenWidth = window.innerWidth;
    },

    emitOpenSearchModal(orderId) {
      this.$emit("openSearchModal", orderId);
    },

    emitOpenPreviewNewLockerProducts() {
      this.$emit("openPreviewNewLockerProducts");
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
#app {
  .snapsheet-page {
    height: 100%;
    width: 100%;
    padding: 3em 2em 3em 3em;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: visible;
    position: relative;

    &.create-mode {
      padding: 1.5em 2em 1.5em 3em;
    }

    .mini-dealer-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 3em;
      width: 100%;

      .rep-info {
        display: flex;
        flex-wrap: wrap;
        .rep-name {
          font-weight: bold;
          margin-bottom: 0.5em;
          width: 100%;
        }
        .rep-phone,
        .rep-email {
          display: flex;
          align-items: center;
          margin-right: 2em;
        }
      }
      img.d-img {
        margin-right: 1em !important;
        max-height: 1.25em !important;
        max-width: 1.25em !important;

        &.dealer-logo {
          margin-right: 1em !important;
          max-height: 6em !important;
          max-width: 6em !important;
        }
      }
    }

    .project-title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5em 2em;
      border-bottom: 3px solid #666;
      .form-control {
        width: 50%;
        padding: 6px;
        border-radius: 3px;
        border: 1px solid #666;
      }
      .edit-action-buttons {
        width: 50%;
        display: flex;
        justify-content: flex-end;
        button {
          width: 100px;
          margin: 0 5px;
          display: block;
          padding: 0.4em;
          background-color: white;
          border-radius: 7px;
          border: none;
          box-shadow: 0 0 10px -2px #0000004d;
          color: black;
          font-family: "SlateStd";
          font-weight: bold;
          text-transform: uppercase;
          transition: box-shadow 0.2s ease;
          transition: background-color 0.15s ease;
          transition: color 0.15s ease;
          &:hover {
            cursor: pointer;
            color: white;
            background-color: black;
          }
          &.save {
            color: white;
            background-color: black;
          }
        }
      }
      .project-title-edit-action {
        font-size: 1em;
        color: #666;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    ::v-deep .product {
      height: 30%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 2em;
      .product-preview {
        width: 30%;
        height: 100%;

        svg {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .product-info {
        width: 65%;
        margin: 0;
      }
    }

    .placeholder-text {
      color: $grey-dark;
      text-align: center;
      width: 55%;
      height: 30%;
      margin: auto;
    }

    .page-footer {
      grid-area: 5/1/-1/-1;
      font-family: "ForzaBold";
      font-weight: bold;
      padding: 5px 15px;
    }

    .footer-explainer {
      color: $grey-dark;
      text-align: center;
      font-size: 0.75em;
    }

    &:last-of-type {
      .page-footer {
        text-align: right;
      }
    }

    &:first-of-type {
      .page-footer {
        text-align: left;
      }
    }

    @media screen and (max-width: 1024px) {
      .list9 {
        /* grid-template-rows: repeat(3,  max(340px, auto)); */
      }
    }

    @media screen and (max-width: 576px) {
      .list {
        /* grid-template-rows: repeat(3, minmax(285px, auto)); */
      }
    }
  }

  .list-item {
    /* display: inline-block;
    margin-right: 10px; */
    /* transform: translateX(0px); */
  }
  .list-enter-active,
  .list-leave-active {
    /* display: none; */
    transition: all 0.2s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    /* transform: translateX(30px); */
  }

  .list-enter,
  .list-enter-active {
    display: none;
  }
}
</style>
